import React from "react";
import PropTypes from "prop-types";

import Paper from "@material-ui/core/Paper";
import "./PageLayout.css";

const PageLayout = ({ children }) => {
  return <Paper className="rootPage">{children}</Paper>;
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageLayout;
